export const PAGINATION_CURRENT_PAGE = 0;
export const PAGINATION_START = 0;
export const PAGINATION_LIMIT = 50;

export const COLUMNS = [
  {
    field: "clientName",
    header: "Nom",
    resizeable: true,
    alignHeader: 'center',
    align: 'left',
    style: {
      width: "180px"
    },
  },
  {
    field: "manager.name",
    header: "GD",
    alignHeader: 'center',
  },
  {
    field: "rdv",
    header: "RDV Date",
    alignHeader: 'center',
    style: {
      width: "200px"
    },
  },
  {
    field: "status",
    header: "Statut",
    alignHeader: 'center',
    style: {
      width: "160px"
    },
  },
  {
    field: "comment",
    header: "Commentaire",
    alignHeader: 'center',
    align: 'center',
    style: {
      width: "500px"
    },
  },
  {
    field: "actions",
    header: "Actions",
    alignHeader: 'center',
    align: 'center',
  },
];
